import { useEffect, useRef } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { HiRefresh } from "react-icons/hi";
import DashboardPage from '../../components/DashboardPage/DashboardPage';
import ErrorLayout from '../../components/Error/ErrorLayout';
import ToasterList, { useToaster } from '../../components/Toaster/ToasterList';
import CreateDomainModal from '../../features/domains/components/CreateDomainModal';
import ListDomain from '../../features/domains/components/ListDomain';
import { domainState, listDomains } from '../../features/domains/domainSlice';
import { useAppDispatch, useAppSelector } from '../../hooks/redux/hooks';

const Domains = () => {

    const dispatch = useAppDispatch();
    const handleRefresh = () => {
        dispatch(listDomains());
    };

    const { toastList, addToast } = useToaster();

    const { createdDomain, deletedDomain, list: domainsList } = useAppSelector(domainState);
    const createdDomainRef = useRef("");
    useEffect(() => {
        if (deletedDomain.isSuccess) {
            addToast({ idx: 'domainDeleted', theme: 'success', title: 'Success', body: () => (<>Successfully deleted the domain</>) });
        }
        if (createdDomain.isSuccess && createdDomain.domain) {
            createdDomainRef.current = createdDomain.domain.name as string;
            addToast({ idx: 'domainCreated', theme: 'success', title: 'Success', body: () => (<>Woohoo, domain creation complete !</>) });

        }
    }, [createdDomain, deletedDomain]);
    
    useEffect(() => {
        if (createdDomain.error) {
            const error = createdDomain.error;
            addToast({ idx: 'domainError', theme: 'danger', title: 'Error', body: () => <ErrorLayout error={error} /> });
        } else if (deletedDomain.error) {
            const error = deletedDomain.error;
            addToast({ idx: 'domainError', theme: 'danger', title: 'Error', body: () => <ErrorLayout error={error} /> });
        }
    }, [createdDomain, deletedDomain, domainsList, domainsList]);

    return (
        <>
            <DashboardPage heading="Settings">
                <Card>
                    <Card.Header>
                        <Row>
                            <Col md={8} sm={7} xs={7}>
                                <Card.Title className="mb-2">Domains</Card.Title>
                                <Card.Subtitle className="text-muted">Create your own Smash domain to send and/or receive files.</Card.Subtitle>
                            </Col>
                            <Col className="hstack gap-3 d-flex justify-content-end align-items-center">
                                <Button variant="light" onClick={handleRefresh}><HiRefresh /> </Button>
                                <CreateDomainModal />
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body>
                        <ListDomain />
                    </Card.Body>
                </Card>
            </DashboardPage>
            <ToasterList list={toastList} />
        </>
    )
}

export default Domains